import React from 'react';
import styled from 'styled-components';

import { NightsPreset } from '../NightsPreset/NightsPreset';

import type { INightsPresetPicker } from './types';

import { NIGHTS_PRESET_NAME_TO_ICON } from './constants';
import { ConditionalScrollable } from '../../../Scrollable';

export const NightsPresetPicker = (props: INightsPresetPicker): JSX.Element => {
  const { selectedDuration, nightsIntervalPreset, handleSelect, nightsPresets, isMobile } = props;

  const selectedPresetName = selectedDuration || nightsIntervalPreset?.name;

  const presetButtonsInfo = nightsIntervalPreset
    ? [nightsIntervalPreset, ...nightsPresets]
    : nightsPresets;

  return (
    <ConditionalScrollable offset={8} applyScroll={isMobile}>
      <PresetsContainer $isMobile={isMobile}>
        {presetButtonsInfo.map((nightsPreset) => (
          <NightsPreset
            key={nightsPreset.name}
            {...nightsPreset}
            icon={NIGHTS_PRESET_NAME_TO_ICON[nightsPreset.name]}
            isSelected={nightsPreset.name === selectedPresetName}
            handleClick={() => handleSelect(nightsPreset.name)}
            isMobile={isMobile}
          />
        ))}
      </PresetsContainer>
    </ConditionalScrollable>
  );
};

export const PresetsContainer = styled.div<{ $isMobile: boolean }>`
  margin-top: 12px;

  ${({ $isMobile }) =>
    $isMobile &&
    `
      display: inline-block;
  `}
`;
